import { cn } from '@/lib/utils';

export type ImageAccordionProps = {
  image: React.ReactNode;
  children: React.ReactNode;
};

export function ImageAccordions({ image, children }: ImageAccordionProps) {
  return (
    <div className='flex w-full flex-row gap-20'>
      <div className='flex flex-[2]'>{children}</div>
      <div className={cn('hidden flex-1 md:flex')}>{image}</div>
    </div>
  );
}
